import { mathRound, androidPort, appPort, wechatPort, versionCompare } from '@/widget';
import { Toast } from 'vant';
import { ref } from 'vue';
// 获取手机pageview 高度
export const useAppPageBar = () => {
    let barH = Number(window.barHeight || 0);
    if (!barH) {
        if (androidPort() && appPort() && versionCompare('8.2.0')) {
            barH = window.JavaScriptInterface.getStatusBarHeight();
        }
        else {
            barH = 44;
        }
    }
    let rem = Number(localStorage.getItem('rem') || 100);
    // n 是一倍图的值
    const getRemH = () => {
        return mathRound((barH * (100 / rem)) / 100, 2);
    };
    const pxToRem = (n) => {
        return mathRound((n * rem) / 100 / 100, 2);
    };
    return {
        barH,
        rem,
        getRemH,
        pxToRem
    };
};
const remToPx = (n) => {
    var rem = localStorage.getItem('rem');
    return (n * Number(rem)) / 100;
};
// 微信唤起app
export const useWxLaunchApp = () => {
    const isWechat = ref(wechatPort());
    const btnStyle = ref({
        width: remToPx(680) + 'px',
        height: remToPx(216) + 'px'
    });
    const handleLaunchFn = () => {
        // 回调成功，判断是否唤起app
        let fn = function () {
            let timeOut = setTimeout(() => {
                if (document.visibilityState === 'visible') {
                    if (androidPort()) {
                        window.open('https://a.app.qq.com/o/simple.jsp?pkgname=com.example.haoyishu');
                    }
                    else {
                        window.open('https://apps.apple.com/cn/app/%E5%A5%BD%E5%8C%BB%E6%9C%AF/id1080080087');
                    }
                }
                else {
                    clearTimeout(timeOut);
                    document.removeEventListener('visibilitychange', fn, false);
                }
            }, 1500);
        };
        document.addEventListener('visibilitychange', fn, false);
    };
    const handleErrorFn = err => {
        let errMsg = err.detai?.errMsg;
        if (errMsg === 'launch:fail_check fail') {
            // appId 校验失败
            Toast('appId校验失败');
        }
        else if (errMsg === 'launch:fail') {
            // 跳转失败 手机上可能没有安装App
            Toast('请确认是否安装好医术APP');
        }
        else if (errMsg) {
            Toast(errMsg);
        }
    };
    const launchReady = e => {
        console.log(e, 'ready1');
    };
    const getBtnStyle = (w, h) => {
        return {
            width: remToPx(w) + 'px',
            height: remToPx(h) + 'px'
        };
    };
    return {
        isWechat,
        btnStyle,
        handleLaunchFn,
        handleErrorFn,
        launchReady,
        getBtnStyle
    };
};
